import { createAction } from '../../utils/redux/createAction';

const actionsScope = 'health-board/appointment-details';

export const APPOINTMENT_DETAILS_TYPES = {
  SET_APPOINTMENT_ID: `${actionsScope}/set-appointment-id`,
  SET_COUPON: `${actionsScope}/set-coupon`,
  SET_ORDER_ID: `${actionsScope}/set-order-id`,
  REPLACE_APPOINTMENT: `${actionsScope}/replace-appointment`,
  START_PAYMENT_PROCESS: `${actionsScope}/start-payment-process`,
  PAYMENT_SUCCESS: `${actionsScope}/payment-success`,
  VISIT_CONFIRMED: `${actionsScope}/visit-confirmed`,
  PAYMENT_TIMEOUT: `${actionsScope}/payment-timeout`,
  PAYMENT_FAIL: `${actionsScope}/payment-fail`,
  CLEAR_PAYMENT: `${actionsScope}/clear-payment`,
  CHANGE_STATUS: `${actionsScope}/change-status`,
  SLICE_UPCOMING_APPOINTMENT: `${actionsScope}/slice-upcoming-appointment`,
};

export const appointmentDetailsActions = {
  setAppointmentId: createAction(APPOINTMENT_DETAILS_TYPES.SET_APPOINTMENT_ID),
  setCoupon: createAction(APPOINTMENT_DETAILS_TYPES.SET_COUPON),
  setOrderId: createAction(APPOINTMENT_DETAILS_TYPES.SET_ORDER_ID),
  clearPayment: createAction(APPOINTMENT_DETAILS_TYPES.CLEAR_PAYMENT),
  replaceAppointment: createAction(
    APPOINTMENT_DETAILS_TYPES.REPLACE_APPOINTMENT,
  ),
  paymentSuccess: createAction(APPOINTMENT_DETAILS_TYPES.PAYMENT_SUCCESS),
  paymentFail: createAction(APPOINTMENT_DETAILS_TYPES.PAYMENT_FAIL),
  paymentTimeout: createAction(APPOINTMENT_DETAILS_TYPES.PAYMENT_TIMEOUT),
  confirmVisit: createAction(APPOINTMENT_DETAILS_TYPES.VISIT_CONFIRMED),
  changeStatus: createAction(APPOINTMENT_DETAILS_TYPES.CHANGE_STATUS),
  sliceUpcomingAppointment: createAction(
    APPOINTMENT_DETAILS_TYPES.SLICE_UPCOMING_APPOINTMENT,
  ),
  startPaymentProcess: createAction(
    APPOINTMENT_DETAILS_TYPES.START_PAYMENT_PROCESS,
  ),
};

const initialState = {
  activeId: undefined,
  coupon: null,
  orderId: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case APPOINTMENT_DETAILS_TYPES.SET_APPOINTMENT_ID: {
      return { ...state, activeId: payload };
    }
    case APPOINTMENT_DETAILS_TYPES.SET_COUPON: {
      return { ...state, coupon: payload };
    }
    case APPOINTMENT_DETAILS_TYPES.SET_ORDER_ID: {
      return { ...state, orderId: payload };
    }
    case APPOINTMENT_DETAILS_TYPES.CLEAR_PAYMENT: {
      return { ...state, coupon: null, orderId: null };
    }

    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/redux/healthboard/appointment-details.js